import { create } from 'zustand'
import type { SponsorTranslations } from '@/lib/contract'

/* Spec PWA-020 D-04 — traducoes que vieram no envelope das respostas ({ data, translations }), por idioma de destino e
   texto original. So em memoria: some ao recarregar e volta com a proxima resposta (o servidor guarda o cache). */

export type ContentTranslation = { text: string; from: string }

type TranslationsState = {
    byLocale: Record<string, Record<string, ContentTranslation>>
    add: (translations: SponsorTranslations) => void
}

export const useTranslationsStore = create<TranslationsState>((set) => ({
    byLocale: {},
    add: ({ to, items }) => {
        if (!items.length) return
        set(state => ({
            byLocale: {
                ...state.byLocale,
                [to]: { ...state.byLocale[to], ...Object.fromEntries(items.map(i => [i.source, { text: i.text, from: i.from }])) },
            },
        }))
    },
}))
